export enum VoucherDiscountType {
  Percent = 'percent',
  Absolute = 'absolute'
}
